module.exports = __webpack_public_path__ + "static/media/13.14f07d1d.jpg";